export default "__VITE_ASSET__aa51adab__"